import { useAuth } from './useAuth';

export type UserRole = 'admin' | 'agent';

export const useUserRole = () => {
  const { user } = useAuth();

  const getUserRole = (): UserRole | null => {
    if (!user) return null;
    
    // Check user_metadata first (user-editable)
    const userRole = user.user_metadata?.role;
    if (userRole && (userRole === 'admin' || userRole === 'agent')) {
      return userRole as UserRole;
    }
    
    // Check app_metadata (admin-only editable)
    const appRole = user.app_metadata?.role;
    if (appRole && (appRole === 'admin' || appRole === 'agent')) {
      return appRole as UserRole;
    }
    
    // If user exists but has no role metadata, assign default 'agent' role
    // This prevents users from losing sidebar functionality
    console.warn('User has no role metadata, assigning default "agent" role for user:', user.email);
    return 'agent';
  };

  const isAdmin = (): boolean => {
    return getUserRole() === 'admin';
  };

  const isAgent = (): boolean => {
    return getUserRole() === 'agent';
  };

  const hasRole = (role: UserRole): boolean => {
    return getUserRole() === role;
  };

  const hasAnyRole = (roles: UserRole[]): boolean => {
    const userRole = getUserRole();
    return userRole ? roles.includes(userRole) : false;
  };

  return {
    userRole: getUserRole(),
    isAdmin: isAdmin(),
    isAgent: isAgent(),
    hasRole,
    hasAnyRole,
    user,
  };
}; 